import styled, { css, keyframes } from 'styled-components';
import {
  Button as ButtonComponent,
  Checkbox as CheckboxComponent
} from 'junto-ui';
import { palette, tokens } from '@plataforma/components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Header = styled.header`
  width: 100%;
  height: 100.42px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  position: relative;

  & > :nth-child(2) {
    ${() => css`
      animation: ${blink} 3s linear infinite;
    `};
    animation-delay: 0.5s;
    top: 5px;
    left: 0;
  }

  & > :nth-child(3) {
    ${() => css`
      animation: ${blink} 3s linear infinite;
    `};
    animation-delay: 1.25s;
    top: 56px;
    left: 4px;
  }

  & > :nth-child(4) {
    ${() => css`
      animation: ${blink} 2s linear infinite;
    `};
    animation-delay: 0.5s;
    top: 45px;
    left: 24px;
  }

  & > :nth-child(5) {
    ${() => css`
      animation: ${blink} 2.5s linear infinite;
    `};
    animation-delay: 2s;
    top: 79px;
    left: 36px;
  }

  & > :nth-child(6) {
    ${() => css`
      animation: ${blink} 3s linear infinite;
    `};
    animation-delay: 0.75s;
    top: 29px;
    left: 94px;
  }

  & > :nth-child(7) {
    ${() => css`
      animation: ${blink} 2s linear infinite;
    `};
    top: 0px;
    right: 101px;
  }

  & > :nth-child(8) {
    ${() => css`
      animation: ${blink} 2s linear infinite;
    `};
    animation-delay: 1.5s;
    top: 10px;
    right: 32px;
  }

  & > :nth-child(9) {
    ${() => css`
      animation: ${blink} 3s linear infinite;
    `};
    animation-delay: 0.3s;
    top: 24px;
    right: 38px;
  }

  & > :nth-child(10) {
    ${() => css`
      animation: ${blink} 3s linear infinite;
    `};
    animation-delay: 0.9s;
    top: 88px;
    right: 0px;
  }
`;

const blink = keyframes`
  0% {
      opacity: 1;
      transform: scale(1);
    }
  50% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const Star = styled.img`
  position: absolute;
  ${({ width, height }) => css`
    width: ${width}px;
    height: ${height}px;
  `};
`;

export const Logo = styled.img`
  width: 180px;
  height: 52px;
`;

export const Title = styled.h2`
  ${tokens.font['xl-emphasys']};
  color: ${palette['color-white']};
  margin: ${tokens.spacing.xxl} 0 ${tokens.spacing.m} 0;
`;

export const Text = styled.p`
  ${tokens.font.base};
  color: ${palette['color-white']};
`;

export const Checkbox = styled(CheckboxComponent)`
  margin: ${tokens.spacing.xl} 0;
  display: flex;
  justify-content: center;
  padding: 0 15px;
  & > label {
    padding: 0 0 0 8px;
    font-size: 12px;
    line-height: 16px;
    color: ${palette['color-grey-300']};
  }

  & > label > p:first-child {
    margin-bottom: 0;
  }

  & > label > p > a {
    text-decoration: none;
  }

  & > label > p > a > strong {
    color: ${palette['color-white']};
  }

  & > label > p > a > strong {
    color: ${palette['color-white']};
  }

  & > label > span {
    background: transparent;

    &:hover {
      border-color: ${palette['color-white']};
    }
  }

  & > label > input:checked + span {
    background-color: ${palette['color-white']} !important;
    border: ${palette['color-white']} !important;
  }

  & > label > span > svg > path {
    fill: transparent;
  }
  & > label > input:checked + span > svg > path {
    fill: ${palette['color-dark']};
  }
`;

export const Button = styled(ButtonComponent)`
  ${tokens.font.base};
  background-color: transparent;
  border: 1px solid ${palette['color-white']};
  color: ${palette['color-white']};
  width: 100%;

  & svg > circle {
    stroke: ${palette['color-white']};
  }

  &:disabled {
    background-color: transparent;
    border: 1px solid ${palette['color-white']};
    color: ${palette['color-white']};
    opacity: 0.3;
  }
`;
